import { trackEvent } from './track-event'

export function trackChangeWishlist() {
  trackEvent({
    event: 'select_wishlist',
    event_name: 'user_interaction',
    action: 'click - wishlist-changed',
  })
}
